const MainContainer = ({
  children,
  header = " ",
  onEdit,
  isDisable = false,
  disableReason = "Not Allowed",
  note = ""
}) => {
  return (
    <div
      className={`w-full my-4 bg-white px-4 md:px-8 ${header ? "py-6" : ""
        } rounded-xl`}
    >
      {header && (
        <div className="flex items-end justify-between gap-[5px] mb-4">
          <div>
            <h2 className="font-bold text-xl md:text-2xl">{header}</h2>
            {onEdit && (
              <p
                className={`text-xl font-bold ${isDisable
                  ? "cursor-not-allowed text-gray-500"
                  : "cursor-pointer text-accent hover:text-amber-700 duration-100"
                  }`}
                onClick={isDisable ? () => { } : onEdit}
                title={isDisable ? disableReason : ""}
              >
                (edit)
              </p>
            )}
          </div>
          {note && <div className="text-gray-500 text-sm italic"><i>{note}</i></div>}
        </div>
      )}
      {children}
    </div>
  );
};

export default MainContainer;
